import { render, staticRenderFns } from "./InfoautoOrderMigrationData.vue?vue&type=template&id=9d7a013c&scoped=true"
import script from "./InfoautoOrderMigrationData.vue?vue&type=script&lang=js"
export * from "./InfoautoOrderMigrationData.vue?vue&type=script&lang=js"
import style0 from "./InfoautoOrderMigrationData.vue?vue&type=style&index=0&id=9d7a013c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a013c",
  null
  
)

export default component.exports